/**
 * Constants for the Graphs feature
 * Defines default numeric fields and their configurations
 */

/**
 * Default numeric fields configuration for chart display
 * Each field defines how to access, format, and display tracking data
 */
export const DEFAULT_NUMERIC_FIELDS = [
  {
    key: 'velocity.speed',
    label: 'Speed',
    unit: 'km/h',
    accessor: (point) => {
      const speed = point?.velocity?.speed ?? point?.['velocity.speed'];
      return speed != null ? speed * 3.6 : null;
    },
    formatter: (value) => value?.toFixed(1) ?? 'N/A',
    color: '#3b82f6', // Blue
  },
  {
    key: 'voltage.external',
    label: 'External Battery Voltage',
    unit: 'V',
    accessor: (point) => point?.voltage?.external ?? point?.['voltage.external'] ?? null,
    formatter: (value) => value?.toFixed(2) ?? 'N/A',
    color: '#10b981', // Green
  },
  {
    key: 'voltage.internal',
    label: 'Internal Battery Voltage',
    unit: 'V',
    accessor: (point) => point?.voltage?.internal ?? point?.['voltage.internal'] ?? null,
    formatter: (value) => value?.toFixed(2) ?? 'N/A',
    color: '#f59e0b', // Amber
  },
  // {
  //   key: 'mileage',
  //   label: 'Mileage (Distance Traveled)',
  //   unit: 'km',
  //   accessor: (point, index, allPoints) => {
  //     const mileage = point?.mileage ?? point?.['mileage'];
  //     if (mileage == null || !allPoints || allPoints.length === 0) return null;

  //     // Get the first point's mileage as baseline
  //     const firstMileage = allPoints[0]?.mileage ?? allPoints[0]?.['mileage'];
  //     if (firstMileage == null) return null;

  //     // Calculate distance traveled from start (in km)
  //     const distanceTraveled = (mileage - firstMileage) / 1000;
  //     return distanceTraveled >= 0 ? distanceTraveled : null;
  //   },
  //   formatter: (value) => value?.toFixed(1) ?? 'N/A',
  //   color: '#8b5cf6', // Purple
  // },
  // {
  //   key: 'fuel',
  //   label: 'Fuel',
  //   unit: '%',
  //   accessor: (point) => point?.fuel ?? point?.['fuel'] ?? null,
  //   formatter: (value) => value?.toFixed(0) ?? 'N/A',
  //   color: '#ef4444', // Red
  // },
  // {
  //   key: 'gps.position.alt',
  //   label: 'Altitude',
  //   unit: 'm',
  //   accessor: (point) => point?.gps?.position?.alt ?? point?.['gps.position.alt'] ?? null,
  //   formatter: (value) => value?.toFixed(1) ?? 'N/A',
  //   color: '#06b6d4', // Cyan
  // },
];

/**
 * Default selected fields when the Graphs tab loads
 * Per Requirements 2.4: Source_Time on x-axis and speed on y-axis as defaults
 * Updated to include speed, external battery voltage, and internal battery voltage
 */
export const DEFAULT_SELECTED_FIELDS = [
  'velocity.speed',
  'voltage.external',
  'voltage.internal',
];

/**
 * Default columns for track points list
 * Per Requirements 6.1: Show Source_Time and speed columns by default
 */
export const DEFAULT_TRACK_POINTS_COLUMNS = ['source_time', 'velocity.speed'];

/**
 * Maximum time range in hours
 * Per Requirements 5.1, 5.2: 24-hour maximum
 */
export const MAX_TIME_RANGE_HOURS = 24;

/**
 * Chart configuration defaults
 */
export const CHART_CONFIG = {
  tension: 0.3,
  pointRadius: 2,
  pointHoverRadius: 6,
  highlightPointRadius: 8,
  highlightPointBorderWidth: 3,
  highlightPointBorderColor: '#000000',
};
